<template>
  <span class="notifications-counter" v-show="count > 0">
    {{ count > 999 ? "···" : count }}
  </span>
</template>

<script setup lang="ts">
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { computed, onMounted } from "vue";

  const auctionStore = useAuctionStore();
  const count = computed(() => auctionStore.notifications.length);

  onMounted(auctionStore.initNotifications);
</script>
